import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  padding: 12px 24px;
  display: flex;
  pointer-events: none;
`;

const StyledNotificationArea = styled.div`
  width: 30%;
  height: 40px;
  margin-left: auto;
  margin-right: auto;

  vertical-align: middle;
  display: ${p => (p.hidden ? 'none' : 'flex')};
  pointer-events: auto;

  &:hover div {
    opacity: 0.5;
  }
`;

const StyledNotificationBox = styled.div`
  width: 100%;
  background: ${p => p.theme.colors.vmNotificationBackground};
  border-radius: 5px;
  border-style: solid;
  border-width: 1px;
  border-color: ${p => p.theme.colors.black};
  transition: opacity 0.25s linear;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledNotificationMessage = styled.div`
  text-align: center;
  font-size: ${p => p.theme.fontSize.base};
  color: ${p => p.theme.colors.vmNotification};
`;

interface Props {
  messages: string[];
}

const VMNotification = (props: Props) => {
  return (
    <StyledContainer>
      <StyledNotificationArea hidden={props.messages.length === 0}>
        <StyledNotificationBox>
          {props.messages.map((message, index) => (
            <StyledNotificationMessage key={index}>
              {message}
            </StyledNotificationMessage>
          ))}
        </StyledNotificationBox>
      </StyledNotificationArea>
    </StyledContainer>
  );
};

export { VMNotification };
